const MAX_DATE_RATE_DAYS = 90;

export { MAX_DATE_RATE_DAYS };
